package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
fun IntroTextoProjecto(isMobile: Boolean) {
    Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
        val fontSize = if (isMobile) 18.px else 45.px   // era 45.px
        val paddingH = if (isMobile) 20.px else 0.px

        SpanText(
            modifier = Modifier.fontSize(fontSize).fontFamily("museomoderno")
                .overflow(Overflow.Hidden).lineHeight(1.2).color(PretoDesfalecido)
                .textAlign(TextAlign.Center).padding(leftRight = paddingH),
            text = if (isMobile)
                "A animação permite preservar símbolos antigos e, ao mesmo tempo, projectar universos novos."
            else "A animação permite preservar símbolos antigos e, ao mesmo"
        )
        if (!isMobile) {
            SpanText(
                modifier = Modifier.fontSize(fontSize).fontFamily("museomoderno")
                    .overflow(Overflow.Hidden).lineHeight(1.1).color(PretoDesfalecido),
                text = "tempo, projectar universos novos."
            )
        }

        Box(modifier = Modifier.height(if (isMobile) 32.px else 80.px))

        SpanText(
            modifier = Modifier.fontSize(fontSize).fontFamily("museomodernoboldItalic")
                .overflow(Overflow.Hidden).lineHeight(1.1).color(PretoDesfalecido)
                .textAlign(TextAlign.Center).padding(leftRight = paddingH),
            text = "Confira à jornada dos nossos animadores"
        )
    }
}